import React from 'react';
import { G } from './gatewayTokens';
import CoinGeckoAttribution from './CoinGeckoAttribution';

// The ONE platform footer rail — the entry-gateway (Landing / Sign in) footer, used verbatim across the
// terminal (admin / pro / free) and the account page so every surface reads as one system. Two centred
// lines: the house mantra, then the copyright + legal links. The legal links point OUT to the company
// site (Privacy · Terms · Refund Policy · FAQ) in a new tab.

const SITE_PRIVACY = 'https://saa-alliance.com/privacy-policy-scientific-analytics-alliance/';
const SITE_TERMS = 'https://saa-alliance.com/terms-of-use-scientific-analytics-alliance/';
const SITE_REFUND = 'https://saa-alliance.com/refund-policy/';
// CoinGecko attribution (both lines, see CoinGeckoAttribution) — required wherever CoinGecko data is shown.
const SITE_FAQ = 'https://saa-alliance.com/faq-platform-validation-security-access-scientific-analytics-alliance/';


// The registered address is shown ONLY on the Pricing page (where the product is sold): one line in the
// footer's bottom-left corner; the footer grows by exactly that line's height. The canonical centred rail is
// identical on every page.
const REGISTERED_ADDRESS = '8 The Green, STE B, Dover, DE 19901, USA';

// ONE typography for both footer lines — the mantra's (owner 2026-09-25).
const RAIL: React.CSSProperties = { color: G.STEEL, fontFamily: G.MONO, fontSize: 10.5, letterSpacing: '0.2em', textTransform: 'uppercase' };

export default function GatewayFooter({ showAddress = false }: { showAddress?: boolean } = {}) {
  const items: React.ReactNode[] = [
    <span key="c">© {new Date().getFullYear()} Scientific Analytics Alliance Inc.</span>,
    <span key="s">Sovereign Risk Infrastructure</span>,
    <a key="p" href={SITE_PRIVACY} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }} className="hover:text-[#94A3B8] transition-colors">Privacy Policy</a>,
    <a key="t" href={SITE_TERMS} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }} className="hover:text-[#94A3B8] transition-colors">Terms of Use</a>,
    <a key="r" href={SITE_REFUND} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }} className="hover:text-[#94A3B8] transition-colors">Refund Policy</a>,
    <a key="f" href={SITE_FAQ} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }} className="hover:text-[#94A3B8] transition-colors">FAQ</a>,
  ];
  return (
    <footer className={`shrink-0 relative px-4 md:px-10 lg:px-20 pt-6 ${showAddress ? 'pb-11' : 'pb-6'}`} style={{ borderTop: '1px solid rgba(255,255,255,0.06)', fontFamily: G.MONO }}>
      <div className="flex flex-col items-center gap-2.5 text-center">
        <div style={RAIL}>
          Math first&nbsp;&nbsp;·&nbsp;&nbsp;Agents second&nbsp;&nbsp;·&nbsp;&nbsp;Governor always&nbsp;&nbsp;·&nbsp;&nbsp;Audit forever
        </div>
        <div style={{ ...RAIL, lineHeight: 1.9 }}>
          {items.map((el, i) => (
            <React.Fragment key={i}>
              {i > 0 && <>{' '}<span aria-hidden style={{ margin: '0 8px' }}>·</span>{' '}</>}
              <span style={{ whiteSpace: 'nowrap' }}>{el}</span>
            </React.Fragment>
          ))}
        </div>
        <div style={{ ...RAIL, fontSize: 11.5, letterSpacing: '0.06em', textTransform: 'none', color: '#94A3B8' }}>
          <CoinGeckoAttribution className="hover:text-[#CBD5E1] transition-colors" style={{ fontSize: 11.5 }} />
        </div>
      </div>
      {showAddress && (
        <div className="absolute left-4 md:left-6 lg:left-8 bottom-3" style={{ ...RAIL, textTransform: 'none', letterSpacing: '0.12em', color: G.DIM, whiteSpace: 'nowrap' }}>
          {REGISTERED_ADDRESS}
        </div>
      )}
    </footer>
  );
}
